import { Service } from '@genial/services';
import { BasketEnumsBasketAdvisorFlowEnum } from '@genial/services/dist/models';

import { screenName } from '../../../store/batchTicket/constants';

export const cancelAdvisorBasketService = async (basketAdvisorOrderId: string) => {
  const { data, statusCode } = await Service.Basket.V1.patchBasketAdvisorByStatus({
    basketAdvisorOrderId,
    screenName,
    basketAdvisorStatusRequest: { statusId: 4301 },
  });

  if (statusCode === 200) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};

export const updateFlowStatusAdvisorBasketService = async (
  basketAdvisorOrderId: string,
  flowOrder: BasketEnumsBasketAdvisorFlowEnum
) => {
  await Service.Basket.V1.patchBasketAdvisorByFlow({
    basketAdvisorOrderId,
    screenName,
    updateBasketAdvisorFlowRequest: { flowOrder },
  });
};

export const patchBasketAdvisorByAccepted = async (
  basketAdvisorOrderId: string,
  notificationChannels: string[]
) => {
  const { data } = await Service.Basket.V1.patchBasketAdvisorByAccepted({
    basketAdvisorOrderId,
    screenName,
    basketAdvisorAcceptRequest: { notificationChannels },
  });

  return data.basketAdvisorOrder;
};

export * from './customers';
export * from './products';
